// import router from "@/router";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const GarResourceRepository = RepositoryFactory.get("garResource");

const actions = {
  // eslint-disable-next-line no-empty-pattern
  getGarResource({}) {
    return GarResourceRepository.getGarResource().then((response) => {
      let resourceData = response.data;

      window.location.href = resourceData.location;
    });
  },
  // eslint-disable-next-line no-empty-pattern
  getGarResourceTicket({}, query) {
    return GarResourceRepository.getGarResourceTicket(query)
      .then((response) => {
        const user_id = response.data.attributes.id;
        const credentials = {
          email: user_id,
          password: "dummy",
        };
        return credentials;
      })
      .catch((response) => {
        console.log("catch error", response);
      });
  },
};

export default {
  namespaced: true,
  actions,
};
